import { render } from "./AccountIdCodePage.vue?vue&type=template&id=5e1155b8&scoped=true&ts=true"
import script from "./AccountIdCodePage.vue?vue&type=script&lang=ts"
export * from "./AccountIdCodePage.vue?vue&type=script&lang=ts"

import "./AccountIdCodePage.vue?vue&type=style&index=0&id=5e1155b8&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1155b8"]])

export default __exports__